/**
 * Public-domain score data generated from Mutopia MIDI.
 * Source: https://www.mutopiaproject.org/cgibin/piece-info.cgi?id=75
 * Work: Minuet in G major, BWV Anh. 114 — Christian Petzold
 * Mutopia edition/typesetting explicitly placed in the public domain.
 */
import type { MusicPiece } from './types.js';

export const PUBLIC_DOMAIN_PIECES: MusicPiece[] = [
  {
    "id": "repertoire-petzold-minuet-g-complete",
    "title": "Minuet in G major, BWV Anh. 114 (Complete)",
    "category": "repertoire",
    "bpm": 140,
    "timeSignature": "3/4",
    "key": "G major",
    "hand": "both",
    "stage": 8,
    "description": "Complete public-domain keyboard score by Christian Petzold, formerly attributed to J. S. Bach.",
    "notes": [
      {
        "beat": 0,
        "duration": 2,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 0,
        "duration": 2,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 0,
        "duration": 2,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 0,
        "duration": 1,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 1,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 1.5,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 2,
        "duration": 1,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 2,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 2.5,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 3,
        "duration": 3,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 3,
        "duration": 1,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 4,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 5,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 6,
        "duration": 3,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 6,
        "duration": 1,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 7,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 7.5,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 8,
        "duration": 0.5,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 8.5,
        "duration": 0.5,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 9,
        "duration": 3,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 9,
        "duration": 1,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 10,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 11,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 12,
        "duration": 3,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 12,
        "duration": 1,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 13,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 13.5,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 14,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 14.5,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 15,
        "duration": 3,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 15,
        "duration": 1,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 16,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 16.5,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 17,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 17.5,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 18,
        "duration": 1,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 18,
        "duration": 1,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 19,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 19,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 19.5,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 20,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 20,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 20.5,
        "duration": 0.3854166666666667,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 20.885416666666668,
        "duration": 0.11197916666666667,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 21,
        "duration": 1,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 21,
        "duration": 3,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 22,
        "duration": 0.5,
        "midi": 50,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 22.5,
        "duration": 0.5,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 23,
        "duration": 0.5,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 23.5,
        "duration": 0.5,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 24,
        "duration": 2,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 24,
        "duration": 1,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 25,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 25.5,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 26,
        "duration": 1,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 26,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 26.5,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 27,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 27,
        "duration": 1,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 28,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 28,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 29,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 29,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 30,
        "duration": 3,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 30,
        "duration": 1,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 31,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 31.5,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 32,
        "duration": 0.5,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 32.5,
        "duration": 0.5,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 33,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 33,
        "duration": 1,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 34,
        "duration": 0.5,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 34,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 34.5,
        "duration": 0.5,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 35,
        "duration": 0.5,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 35,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 35.5,
        "duration": 0.5,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 36,
        "duration": 2,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 36,
        "duration": 1,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 37,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 37.5,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 38,
        "duration": 1,
        "midi": 54,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 38,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 38.5,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 39,
        "duration": 2,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 39,
        "duration": 1,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 40,
        "duration": 0.5,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 40.5,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 41,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 41,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 41.5,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 42,
        "duration": 1,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 42,
        "duration": 1,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 43,
        "duration": 1,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 43,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 43.5,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 44,
        "duration": 1,
        "midi": 50,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 44,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 44.5,
        "duration": 0.5,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 45,
        "duration": 2,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 45,
        "duration": 3,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 47,
        "duration": 1,
        "midi": 43,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 48,
        "duration": 3,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 48,
        "duration": 1,
        "midi": 83,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 49,
        "duration": 0.5,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 49.5,
        "duration": 0.5,
        "midi": 81,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 50,
        "duration": 0.5,
        "midi": 83,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 50.5,
        "duration": 0.5,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 51,
        "duration": 3,
        "midi": 54,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 51,
        "duration": 1,
        "midi": 81,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 52,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 52.5,
        "duration": 0.5,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 53,
        "duration": 0.5,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 53.5,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 54,
        "duration": 1,
        "midi": 52,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 54,
        "duration": 1,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 55,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 55,
        "duration": 0.5,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 55.5,
        "duration": 0.5,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 56,
        "duration": 1,
        "midi": 52,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 56,
        "duration": 0.5,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 56.5,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 57,
        "duration": 2,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 57,
        "duration": 1,
        "midi": 73,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 58,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 58.5,
        "duration": 0.5,
        "midi": 73,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 59,
        "duration": 1,
        "midi": 45,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 59,
        "duration": 1,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 60,
        "duration": 3,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 60,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 60.5,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 61,
        "duration": 0.5,
        "midi": 73,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 61.5,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 62,
        "duration": 0.5,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 62.5,
        "duration": 0.5,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 63,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 63,
        "duration": 1,
        "midi": 79,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 64,
        "duration": 1,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 64,
        "duration": 1,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 65,
        "duration": 1,
        "midi": 61,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 65,
        "duration": 1,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 66,
        "duration": 1,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 66,
        "duration": 1,
        "midi": 78,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 67,
        "duration": 1,
        "midi": 54,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 67,
        "duration": 1,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 68,
        "duration": 1,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 68,
        "duration": 1,
        "midi": 73,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 69,
        "duration": 1,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 69,
        "duration": 3,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 70,
        "duration": 1,
        "midi": 50,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 71,
        "duration": 1,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 72,
        "duration": 2,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 72,
        "duration": 1,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 73,
        "duration": 2,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 73,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 73.5,
        "duration": 0.5,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 74,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 74,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 75,
        "duration": 2,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 75,
        "duration": 1,
        "midi": 76,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 76,
        "duration": 2,
        "midi": 64,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 76,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 76.5,
        "duration": 0.5,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 77,
        "duration": 1,
        "midi": 60,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 77,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 78,
        "duration": 1,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 78,
        "duration": 1,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 79,
        "duration": 1,
        "midi": 57,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 79,
        "duration": 1,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 80,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 80,
        "duration": 1,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 81,
        "duration": 2,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 81,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 81.5,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 82,
        "duration": 0.5,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 82.5,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 83,
        "duration": 1,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 84,
        "duration": 3,
        "midi": 50,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 84,
        "duration": 0.5,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 84.5,
        "duration": 0.5,
        "midi": 64,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 85,
        "duration": 0.5,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 85.5,
        "duration": 0.5,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 86,
        "duration": 1,
        "midi": 54,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 86,
        "duration": 0.5,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 86.5,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 87,
        "duration": 1,
        "midi": 52,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 87,
        "duration": 1,
        "midi": 72,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 88,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 88,
        "duration": 1,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 89,
        "duration": 1,
        "midi": 54,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 89,
        "duration": 1,
        "midi": 69,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 90,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 90,
        "duration": 0.5,
        "midi": 71,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 90.5,
        "duration": 0.5,
        "midi": 74,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 91,
        "duration": 1,
        "midi": 47,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 91,
        "duration": 1,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 92,
        "duration": 1,
        "midi": 50,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 92,
        "duration": 1,
        "midi": 66,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 93,
        "duration": 1,
        "midi": 55,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 93,
        "duration": 3,
        "midi": 59,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 93,
        "duration": 3,
        "midi": 62,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 93,
        "duration": 3,
        "midi": 67,
        "velocity": 90,
        "hand": "right"
      },
      {
        "beat": 94,
        "duration": 1,
        "midi": 50,
        "velocity": 90,
        "hand": "left"
      },
      {
        "beat": 95,
        "duration": 1,
        "midi": 43,
        "velocity": 90,
        "hand": "left"
      }
    ],
    "skills": [
      "Baroque dance",
      "two-voice balance",
      "ornaments",
      "cadence"
    ],
    "completeWork": true
  }
];
